import styled from '@emotion/styled'
import { usePeopleFiltersContext } from '@sales-app/context/peopleFilters/peopleFilters'
import React, { useState } from 'react'

import { Dropdown } from '@/components'

export const TypeFilter = () => {
  const { bookablePersonType, setFilters } = usePeopleFiltersContext()

  const [dropdownExpanded, setDropdownExpanded] = useState(false)

  const types = ['Member', 'Lead']

  const handleCancel = () => {
    setDropdownExpanded(false)
  }

  const changeFilter = (val: string | null = null) => {
    setDropdownExpanded(false)
    if (val) {
      setFilters({ bookablePersonType: val })
    } else {
      setFilters({ bookablePersonType: null })
    }
  }

  return (
    <Dropdown
      className="hidden w-full md:w-auto lg:flex"
      expanded={dropdownExpanded}
      headerTitle="Type"
      onHideDropdown={handleCancel}
      renderHeader={() => <div></div>}
      selected={!!bookablePersonType}
      setExpanded={setDropdownExpanded}
    >
      <FilterOptionsStyled>
        <ul>
          <li
            className={`${!bookablePersonType ? 'selected' : ''}`}
            onClick={() => changeFilter()}
            role={'presentation'}
          >
            All
          </li>
          {types.map((val, i) => (
            <li
              className={`${bookablePersonType === val ? 'selected' : ''}`}
              key={i}
              onClick={() => changeFilter(val)}
              role={'presentation'}
            >
              {val}
            </li>
          ))}
        </ul>
      </FilterOptionsStyled>
    </Dropdown>
  )
}

export const FilterOptionsStyled = styled.div`
  width: 13rem;

  ul {
    width: 100%;
    padding-top: 0.5rem;
    padding-bottom: 0.25rem;
  }
  li {
    &.selected {
      background-color: #e7e6e4;

      &:hover {
        background-color: #e7e6e4;
      }
    }
    margin-bottom: 0.25rem;
    width: 100%;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    cursor: pointer;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    line-height: 1;
    &:hover {
      background-color: #f3f3f2;
    }
  }
`
